import useService from 'hooks/useService'
import React from 'react'

const Header = ({
    title = ''
}) => {
    const { getStorageData } = useService()
    
    return (
        <header className="header p-2">
            {getStorageData('propertydata')?.logo ?
                <img src={getStorageData('propertydata')?.logo} alt="Logo" className="logo" />
                :
                <></>
            }
            <p className="title my-auto">{title}</p>
        </header>
    )
}

export default Header